import { reloadAjaxPagination } from '../../components/ajax-pagination.js';
import { startAutomaticListsSyncPolling } from '../automatic-lists-sync/sync-status-poller.js';
import { formatGameCount } from '../lists-manual-order/manual-games-browser.js';

const RESULTS_SELECTOR = '#automatic-list-games-results';

/**
 * Keeps an automatic list's details page in step with a pending sync: once the sync settles, pagination
 * reloads the games grid in place for the page the reader is on, with the game count in the same commit. A
 * refresh never starts while pagination is loading (a reload would abort that request), and one superseded by
 * a page click or history navigation is refused - the next poll tick retries against the new page.
 */
export function initAutomaticListSyncRefresh(documentRef = globalThis.document, windowRef = globalThis.window) {
    const statusElement = documentRef?.querySelector?.('[data-page-view="lists-details"] [data-lists-sync-status]');
    if (!(statusElement instanceof HTMLElement) || statusElement.dataset.syncPending !== '1') {
        return null;
    }

    async function refresh() {
        const results = documentRef.querySelector(RESULTS_SELECTOR);
        if (!(results instanceof HTMLElement) || results.dataset.loading === 'true') {
            return false;
        }

        const outcome = await reloadAjaxPagination(documentRef, results, (fragment) => {
            const countElement = documentRef.querySelector('[data-lists-details-count]');
            if (countElement instanceof HTMLElement && fragment.totalItems !== null) {
                countElement.textContent = formatGameCount(fragment.totalItems);
            }
        });
        if (outcome === 'not-found') {
            // The sync removed this list; the reload renders the regular not-found page.
            windowRef.location.reload();

            return true;
        }

        return outcome === 'swapped';
    }

    startAutomaticListsSyncPolling({
        statusElement,
        syncStatusUrl: String(statusElement.dataset.syncStatusUrl ?? '').trim(),
        refresh,
    });

    return { refresh };
}
